<button class="oval__button" (click)="onButtonClick()">
  <div class="button__text">{{ buttonText }}</div>
  <div class="button__arrow" [ngClass]="{ 'button__arrow--active': isStateExpanded }"></div>
</button>
